// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__GOi7V","socials":"footer_socials__mrDaB","twitter":"footer_twitter__Od4y-","facebook":"footer_facebook__vE6D9","email":"footer_email__idYKF"};